import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const metrics = [
  {
    value: '24/7',
    label: 'Señal Radio Visual TNO Network',
    subtitle: 'Rotativa continua en streaming y On-Demand',
  },
  {
    value: '+90K',
    label: 'Comunidad TNO en redes',
    subtitle: 'Amplificación de inserts y piezas de Berlud',
  },
  {
    value: '4',
    label: 'Artículos Digest al mes (Plan Oro)',
    subtitle: 'SEO permanente en salud visual y óptica',
  },
  {
    value: '12',
    label: 'Inserts en redes (Plan Oro)',
    subtitle: 'Logo y claqueta en clips del ecosistema',
  },
];

const Alcance = () => {
  const theme = useTheme();

  return (
    <Box>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Alcance
      </Typography>
      <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
        Inventario que escala con cada plan
      </Typography>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {metrics.map((item, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                borderLeft: 4,
                borderColor: theme.palette.primary.main,
                height: '100%',
              }}
            >
              <CardContent>
                <Typography variant="h4" fontWeight={900} color="primary" gutterBottom>
                  {item.value}
                </Typography>
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  {item.label}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.subtitle}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Alcance;
